/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-11-15 13:34:21
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-06-16 16:12:51
 * @Description: 发票收取
 * @FilePath: \ICPSxin\src\api\internetSales\planPayment.js
 */
// export const queryPage = '/icps/system/sign/dataCollection/planPayment/queryPage'
export const Download = '/icps/system/sign/dataCollection/planPayment/exportCurrentPage'
import request from '@/utils/request'
    // 查询支付合同编号
  export function queryPage(data) {
    return request({
      url: "/icps/system/sign/dataCollection/planPayment/queryPage",
      method: "post",
      data,
    });
  }
// 保存发票
export function savePlanPay(data) {
    return request({
      url: "/icps/system/sign/dataCollection/planPayment/saveOrUpdate",
      method: "post",
      data,
    });
  }
    // 查询支付合同编号
  export function queryContractNumber(data) {
    return request({
      url: "/icps/system/sign/dataCollection/planPayment/queryContractNumber",
      method: "post",
      data,
    });
  }
// 删除
  export function batchDelPlanPay(data) {
    return request({
      url: "/icps/system/sign/dataCollection/planPayment/batchDel",
      method: "post",
      data,
    });
  }
